module.exports = "mutation createSales($adviceRequestId:String!,$revenue:RevenueInput!){createSales(adviceRequestId:$adviceRequestId,revenue:$revenue)}"